<template>
  <div class="login-box well white-box">
    <logo-component></logo-component>
    <error-component
        v-if="exceptions.length > 0"
        v-bind="exceptions[0]">
    </error-component>
    <div class="alert alert-success" v-if="success && !this.$route.query.user_id">
      <p>
        An email was sent to {{ email }} to confirm you address. Please check your inbox or spam folder.
        <br/>
        <br/>
        <b-link class="" :to="{ name : 'login' }">
          <a>You are ready, go to Login</a>
        </b-link>
      </p>
    </div>
    <div class="alert alert-success" v-if="success_activate">
      <p>Account activation succesfully. Now you can
        <b-link :to="{ name : 'login' }"><a>log in</a></b-link>
        log in with your credentials.
      </p>
    </div>
    <div class="alert alert-success" v-if="unactive">
      <p>You already have an account, finish your registration</p>
    </div>
    <b-form @submit.prevent="onSubmit" v-if="!success">
      <b-form-group
          label="Name:"
          label-for="name">
        <b-form-input
            name="name"
            id="name"
            v-model="name"
            type="text"
            v-validate="{ required:true }"
            :state="errors.has('name') ? false : null"
            placeholder="Full name">
        </b-form-input>
        <em v-if="errors.has('name')" class="text-danger">
          {{ errors.first('name') }}
        </em>
      </b-form-group>
      <b-form-group
          label="Email:"
          label-for="email">
        <b-form-input
            name="email"
            id="email"
            v-model="email"
            type="text"
            :disabled="unactive"
            v-validate="{ required:true }"
            :state="errors.has('email') ? false : null"
            placeholder="user@example.com">
        </b-form-input>
        <em v-if="errors.has('email')" class="text-danger">
          {{ errors.first('email') }}
        </em>
      </b-form-group>
      <b-form-group
          label="Password:"
          label-for="password">
        <b-form-input
            name="password"
            id="password"
            v-model="password"
            type="password"
            v-validate="{ required:true }"
            :state="errors.has('password') ? false : null"
            placeholder="Password">
        </b-form-input>
        <em v-if="errors.has('password')" class="text-danger">
          {{ errors.first('password') }}
        </em>
      </b-form-group>
      <b-form-group id="termsOfUse">
        <b-form-checkbox
            name="termsOfUse"
            v-model="termsOfUse"
            v-validate="{ required: true }"
            unchecked-value=""
            size="sm">
                        <span>I agree to the
                            <a href="https://www.dataproviders.io/terms-of-service/" target="_blank">
                                terms of service
                            </a>
                        </span>
        </b-form-checkbox>
        <em v-if="errors.has('termsOfUse')" class="text-danger">
          You need to agree with our terms of service
        </em>
      </b-form-group>
      <b-button variant="primary" :disabled="loadingRun" type="submit" class="mr-2">
        <span>Register</span>
        <b-spinner
            v-if="loadingRun"
            small
            class="ml-2"/>
      </b-button>
      <b-link class="btn btn-secondary" :to="{ name : 'login' }">
        <a>Back</a>
      </b-link>
    </b-form>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import ErrorComponent from './ErrorView.vue';
import LogoComponent from './Logo.vue';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      name: '',
      email: '',
      password: '',
      error: false,
      success: false,
      unactive: false,
      success_activate: false,
      loadingRun: false,
      termsOfUse: null,
      token: null,
    };
  },
  created() {
    if (this.$route.query.user_id && this.$route.query.token) {
      let payload = {
        id: this.$route.query.user_id,
        token: this.$route.query.token
      };
      this.$store.dispatch('fetchUnactiveUser', payload)
          .then(res => {
            if (res.data.data.user.active === 0) {
              this.unactive = true;
              this.name = res.data.data.user.name;
              this.email = res.data.data.user.email;
            }
          })
          .catch(error => {
            this.unactive = false;
            this.error = true;
            this.$store.commit('SET_EXCEPTIONS', {message: 'User not allowed to finish registration', data: []});
          })
    }
  },
  mounted() {
    this.recaptchaScript = document.createElement('script');
    this.recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + window.config.recaptcha.key); //@todo : Move this into a config in vue, not sure how to do it yet
    document.head.appendChild(this.recaptchaScript);

    $('html').addClass('login').addClass('register');
  },
  beforeDestroy() {
    $('html').removeClass('register');

    this.$store.commit('CLEAR_EXCEPTIONS');
  },
  computed: {
    ...mapState({
      exceptions: 'exceptions'
    })
  },
  methods: {
    onSubmit() {
      var app = this;

      grecaptcha.ready(function () {
        grecaptcha.execute(window.config.recaptcha.key , {action: 'submit'}) //
          .then(function (token) {

            app.$validator.validateAll().then((valid) => {
              if (valid) {
                app.token = token;
                if (app.unactive) {
                  app.activateUser()
                }
                else {
                  app.register();
                }
              }
            });
          });
      });
    },
    register() {
      this.loadingRun = true;
      this.$auth.register({
        data: {
          name: this.name,
          email: this.email,
          password: this.password,
          token: this.token
        },
        url: 'users',
        success: function (resp) {
          this.success = true;
          this.loadingRun = false;
          this.$store.commit('CLEAR_EXCEPTIONS');
        },
        error: function (resp) {
          this.error = true;
          this.loadingRun = false;
          this.$store.commit('SET_EXCEPTIONS', resp.response.data);
        },
        redirect: null
      });
    },
    activateUser() {
      this.loadingRun = true;
      let data = {
        id: this.$route.query.user_id,
        name: this.name,
        email: this.email,
        password: this.password,
        token: this.token,
      };
      this.$store.dispatch('activateUser', data)
          .then(() => {
            this.success_activate = true;
            this.success = true;
            this.unactive = false;
          })
          .finally(() => {
            this.loadingRun = false;
          });
    },
    goLogin() {
      this.$router.replace({name: 'login'});
    }
  },
  components: {
    ErrorComponent,
    LogoComponent
  }
}
</script>

<style>
#termsOfUse .custom-control-label {
  padding-top: 3px !important;
}


</style>
